module.exports = __webpack_public_path__ + "static/media/background.c9aafe4f.jpg";